'use client';

import { scrollTo } from '@/utils';
import { useFormContext, useFormState, useWatch } from 'react-hook-form';
import { EpButton } from '../../../components';
import { useTranslation as t } from '../../../hooks/useTranslation';
import { useTranslationStore } from '../../../stores';
import { useToasterStore } from '../../../stores/useToasterStore';
import { goToNextStep } from '../../EpWizard';
import { showModal } from '../../EpModal';
import { showAlertToasterByStatusMessage } from '../../EpAlertToaster';
import { usePathname } from 'next/navigation';

export const FormStepButtonNext = ({ isClinicalPharmacy = false }) => {
  const pathname = usePathname();

  const { translations } = useTranslationStore((state) => state);
  const { addSingleToast } = useToasterStore((state) => state);
  const { trigger, setValue, getValues } = useFormContext();
  const [activeStep, totalSteps] = getValues([
    'formUtils.activeStep',
    'formUtils.totalSteps',
  ]);

  const isLogged = !pathname.includes('Public');

  const { errors } = useFormState();
  const Inputs = useWatch({ name: 'formUtils.InputsSteps' })[activeStep - 1];
  const isAnonymous = useWatch({ name: 'anonymous' });

  const notificationTypeId = useWatch({
    name: 'notificationTypeId.inputValue',
  });

  const handleNextPage = async () => {
    if (await trigger(Inputs, { shouldFocus: true })) {
      const { formUtils, notifierEmail } = getValues();

      if (
        !isLogged &&
        formUtils.activeStep === 4 &&
        !notifierEmail &&
        !isAnonymous
      ) {
        showAlertToasterByStatusMessage({
          response: {
            status: 1,
            message: t(
              translations['global'],
              'Without including the email, it will not be possible to check the status of the notification.',
            ),
          },
          alertToasterTitle: t(translations['global'], 'Error'),
          alertToasterShouldShowSuccess: true,
        });
      }

      if (activeStep >= totalSteps - 1) {
        setValue('formUtils.activeStep', activeStep + 1);
      } else {
        goToNextStep();
      }
      scrollTo([
        'ep-card-default',
        'ep-card__body--1',
        'headerNavigationTestPopoverHost',
      ]);
    }

    if (errors) {
      for (const input of Inputs) {
        const questionErrors = errors[input];
        if (input === 'questions') {
          if (Array.isArray(questionErrors)) {
            for (const questionError of questionErrors) {
              if (questionError?.inputValue?.type === 'required') {
                addSingleToast({
                  caption: questionError?.inputValue?.message,
                  type: 'danger',
                });
              }
            }
          }
        }

        /** Checa se o campo é required, se for tem que aparecer o toast indicando que o campo é required */
        if (errors[input]?.type === 'required') {
          //|| errors[input]?.inputValue?.type === 'required')
          addSingleToast({
            caption: 'Campos obrigatórios requisitados.',
            type: 'danger',
          });
        }
      }
    }
  };

  if (activeStep === totalSteps) {
    return null;
  }

  return (
    <EpButton
      buttonSize="md"
      buttonType="primary"
      buttonText={t(translations['global'], 'Next')}
      buttonRightIconName="SolidLongArrowAltRight"
      buttonOnClickFunc={handleNextPage}
      buttonIsDisabled={
        !isClinicalPharmacy && activeStep === 3 && !notificationTypeId
      }
    />
  );
};
